import React, { ReactNode } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';

import classNames from 'classnames';
import styled from 'styled-components';

import { isLocationMatchingMenuItem } from 'utils/helpers/locationMatch';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;
  font-size: 12px;
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px;

  &:hover {
    background-color: var(--sidebar-selector-border);
  }

  &.selected {
    background-color: var(--sidebar-selector-border);
  }
`;

const MenuItemLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const Badge = styled.span`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  border-radius: 2px;
  background-image: linear-gradient(120deg, #88f, #55f 100%);
  font-size: 8px;
  line-height: 1;
  font-family: var(--font-bold);
  color: white;
  text-transform: uppercase;
`;

const IconWrapper = styled.span`
  font-size: 14px;
  margin-right: 10px;
`;

interface Props {
  to: string;
  pattern?: string;
  label: string | ReactNode;
  icon?: ReactNode;
  badge?: string;
}

const SidebarMenuItem = ({ to, pattern, label, icon = null, badge }: Props) => {
  const location = useLocation();

  const isPathMatch = matchPath(pattern || to, location.pathname);
  const menuItemClassnames = classNames({
    selected: isPathMatch || isLocationMatchingMenuItem(pattern || to, location.pathname),
  });
  return (
    <StyledLink to={to}>
      <MenuItem className={menuItemClassnames}>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <MenuItemLabel title={typeof label === 'string' ? label : undefined}>{label}</MenuItemLabel>
        {badge && <Badge>{badge}</Badge>}
      </MenuItem>
    </StyledLink>
  );
};

export default SidebarMenuItem;
